import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-layout-content',
  templateUrl: './layout-content.component.html',
  styleUrls: ['./layout-content.component.scss'],
  standalone: false
})
export class LayoutContentComponent {
  @HostBinding('class.layout-content') readonly binding = true;
}
